var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state",class:{ 'empty-state--restricted': _vm.restricted }},[_c('div',{staticClass:"empty-state-icon"},[_c('i',{class:_vm.iconClass})]),_c('div',{staticClass:"empty-state-title"},[_vm._v(_vm._s(_vm.computedTitle))]),_c('div',{staticClass:"empty-state-text"},[_vm._v(_vm._s(_vm.computedMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }